import i18n from 'i18next';

export function convertUTCDateToLocalDate(date: Date) {
  const newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

  const offset = date.getTimezoneOffset() / 60;
  const hours = date.getHours();

  newDate.setHours(hours - offset);

  return newDate;
}

export function convertDate(jsonDate: string | number) {
  return new Date(jsonDate);
}

/**
 * Localize the URL
 * @param path Complete URL or href part
 * @returns Localized path
 */
export function localeUrl(path: string) {
  if (path && path.indexOf('http') >= 0) return path;
  let retPath: string | null = null;
  if (path && path[0] === '/') {
    retPath = `/${(i18n && i18n.language) || 'en'}${path}`;
  } else {
    retPath = `/${(i18n && i18n.language) || 'en'}/${path}`;
  }
  return retPath.replace('/en/', '/');
}
